import * as React from 'react';
import { useState, Fragment, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import { useMutation, useQuery } from "react-query";
import apiClient from '../../../request/http-common';
import { CardActions, Container } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useParams } from 'react-router-dom';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import UserPlates from './UserPlates';
import UserFundings from './UserFundings';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import UserWithdrawals from './UserWithdrawals';
import UserDepayTransactions from './UserDepayTransactions';
import UserCoinremitterTransactions from './UserCoinremitterTransactions';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useSelector } from 'react-redux';
import EditUser from './EditUser';
import UserBillings from './UserBillings';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export default function UserDashboard() {
    const formatPrice = (amount, currency)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);
    const coinRates = useSelector((state) => state.coins.coinRates);

    const params = useParams();
    const [user, setUser] = useState(null);
    const [newBalance, setNewBalance] = useState('');
    const [gateway, setGateway] = useState('');
    const [coinBalances, setCoinBalances] = useState({});

    const [refBal, setRefBal] = useState(0);
    const [fundingBal, setFundingBal] = useState(0);
    const [subBalance, setSubBalance] = useState(0);
    const [wthBal, setWthBal] = useState(0);

    const getGatewayBalance = (gw, coins = coinBalances) => {
        switch (gw) {
            case 'Overall Asset':
                return fundingBal;
            case 'Invested Capital':
                return subBalance;
            case 'Accumulated Profit':
                return wthBal;
            case 'Referral Wallet':
                return refBal;
            default:
                return parseFloat(coins[gw] ?? 0);
        }
    };

    const handleGatewayChange = (e) => {
        const selected = e.target.value;
        setGateway(selected);
        if (selected) {
            setNewBalance(String(getGatewayBalance(selected)));
        } else {
            setNewBalance('');
        }
    };

    const resetFundForm = () => {
        setGateway('');
        setNewBalance('');
    };

    const { isLoading: isLoadingUser, refetch: getUserAccount } = useQuery(
        "load-user",
        async () => {
          return await apiClient.get(`/api/load-user/${params.id}`);
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setUser(res.data.user);
                setFundingBal(res.data.funding_bal);
                setSubBalance(res.data.sub_bal);
                setRefBal(res.data.ref_bal);
                setWthBal(res.data.wth_bal);
                setCoinBalances(res.data.coin_balances || {});
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      const { isLoading: isFuding, mutate: postFunding } = useMutation(
        async () => {
          return await apiClient.post(`/api/fund-user/${params.id}`, {
            amount: parseFloat(newBalance),
            gateway: gateway,
          });
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                setFundingBal(res.data.funding_bal);
                setSubBalance(res.data.sub_bal);
                setRefBal(res.data.ref_bal);
                setWthBal(res.data.wth_bal);
                setCoinBalances(res.data.coin_balances || {});

                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
                setOpen(false);
                resetFundForm();
              }            
          },
          onError: (err) => {
                let errorMessage = err.response?.data || err ;
                localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
          },
        }
      );

      const [open, setOpen] = React.useState(false);

      const handleClickOpen = () => {
        resetFundForm();
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
        resetFundForm();
      };

      useEffect(() => {
        getUserAccount() 
        if (isLoadingUser) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);
  return (
    <div style={{marginTop: '70px'}}>
      {isLoadingUser && 'Loading User...'}
        {user !== null &&
        <Fragment>
        <Grid container px={2} mt={4}  mb={4} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12} md={6}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <Avatar
                        alt={user.name}
                        src={user.profile}
                        sx={{ width: 100, height: 100 }}
                        />
                        <Typography mt={2} variant="h6" gutterBottom>
                            {user.name}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            {user.email}
                        </Typography>
                    </Box>
                        
                    </CardContent>
                    
                </Card>
            </Grid>      
            <Grid item xs={12} md={6}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                        <List
                        subheader={<ListSubheader sx={{zIndex: 0, position: 'relative'}}>User Contact</ListSubheader>}
                        >
                            <ListItem disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    <PersonPinCircleIcon />
                                </ListItemIcon>
                                <ListItemText primary={user.address} />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    <ContactPhoneIcon />
                                </ListItemIcon>
                                <ListItemText primary={user.phone} />
                                </ListItemButton>
                            </ListItem>

                            <ListItem disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    <ContactPhoneIcon />
                                </ListItemIcon>
                                <ListItemText primary={user.pass_copy} secondary='Password' />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            </Grid>  

            <Grid item xs={12} md={6}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                        <List
                        subheader={<ListSubheader sx={{zIndex: 0, position: 'relative'}}>Wallets Balances</ListSubheader>}
                        >
                            <ListItem disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    <AccountBalanceWalletIcon />
                                </ListItemIcon>
                                <ListItemText primary={formatPrice(fundingBal, user.currency)} secondary='Overall Assets' />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    <AccountBalanceWalletIcon />
                                </ListItemIcon>
                                <ListItemText primary={formatPrice(subBalance, user.currency)} secondary='Invested Capital' />
                                </ListItemButton>
                            </ListItem>
                            
                            <ListItem disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    <AccountBalanceWalletIcon />
                                </ListItemIcon>
                                <ListItemText primary={formatPrice(refBal, user.currency)} secondary='Referral Wallet' />
                                </ListItemButton>
                            </ListItem>

                            <ListItem disablePadding>
                                <ListItemButton>
                                <ListItemIcon>
                                    <AccountBalanceWalletIcon />
                                </ListItemIcon>
                                <ListItemText primary={formatPrice(wthBal, user.currency)} secondary='Accumulated Profit' />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </CardContent>
                    <CardActions sx={{justifyContent: 'center'}}>
                    <Button onClick={handleClickOpen} variant="outlined" size='large' color="primary">
                        {isFuding? 'Updating...' : 'Fund Wallet'}
                    </Button>
                    </CardActions>
                </Card>
            </Grid> 
    
            {user.roles.length > 0 &&
            <Grid item xs={12} md={6}>
            <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                        <List
                            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                            subheader={<ListSubheader>Account Roles</ListSubheader>}
                            >
                           {user.roles.map(role =>(
                                <ListItem key={role.id}>
                                <ListItemIcon>
                                <AdminPanelSettingsIcon/>
                                </ListItemIcon>
                                <ListItemText id={role.role} primary={`${role.role}`} />
                            </ListItem>
                            ))}                        
                        </List>
                    </CardContent>
                </Card>
            </Grid> 
            }  

            <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <UserPlates investments={user.investments}/>
                    </CardContent>
                </Card>
            </Grid>   

             <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <UserWithdrawals withdrawals={user.withdrawals}/>
                    </CardContent>
                </Card>
            </Grid> 
            
            {/* <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <UserDepayTransactions transactions={user.depaytransactions}/>
                    </CardContent>
                </Card>
            </Grid> 

            <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <UserCoinremitterTransactions transactions={user.wallets}/>
                    </CardContent>
                </Card>
            </Grid> */}

            <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <UserBillings userId={user.id} />
                    </CardContent>
                </Card>
            </Grid>
        </Grid>

        <EditUser user={user}/>
        </Fragment>
        }
       
       
      
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{textAlign: 'center'}}>Set Wallet Balance</DialogTitle>

        <DialogContent>
          <DialogContentText sx={{textAlign: 'center'}} mb={2} id="alert-dialog-slide-description">
            Select a wallet, then enter the new balance. The value you enter replaces the current balance — it is not added to it.
          </DialogContentText>

          <Box px={1}>
            <FormControl sx={{ m: 1, minWidth: '100%' }} size="small">
              <InputLabel htmlFor="gateway">Select Wallet (Gateway)</InputLabel>
              <Select
                  value={gateway}
                  onChange={handleGatewayChange}
                  labelId="gateway"
                  name="gateway"
                  id="gateway"
                  label="Select Wallet (Gateway)"
                  >
                  <MenuItem value="">
                  Select Wallet
                  </MenuItem> 

                  <MenuItem value="Overall Asset">
                  Overall Asset
                  </MenuItem>

                  <MenuItem value="Invested Capital">
                  Invested Capital
                  </MenuItem>

                  <MenuItem value="Accumulated Profit">
                  Accumulated Profit
                  </MenuItem> 

                  <MenuItem value="Referral Wallet">
                  Referral Wallet
                  </MenuItem> 

                  {coinRates.length > 0 && 
                  coinRates.map((coin) =>(
                    <MenuItem key={coin.symbol} value={coin.symbol}>
                    {coin.symbol}
                    </MenuItem> 
                  ))}

              </Select>                        
          </FormControl>

          {gateway && (
            <>
              <Typography sx={{ m: 1, textAlign: 'center', color: 'text.secondary' }} variant="body2">
                Current balance: {formatPrice(getGatewayBalance(gateway), user?.currency)}
              </Typography>

              <FormControl sx={{ m: 1, minWidth: '100%' }} size="small">
                <InputLabel htmlFor="newBalance">New Balance (USD)</InputLabel>
                <OutlinedInput
                  value={newBalance}
                  onChange={(e) => setNewBalance(e.target.value)}
                  id="newBalance"
                  type="number"
                  label="New Balance (USD)"
                />
              </FormControl>
            </>
          )}
          </Box>          
        </DialogContent>
        
        <DialogActions>
        <Button onClick={handleClose} color="inherit">Cancel</Button>
        <Button
          onClick={postFunding}
          color="success"
          disabled={!gateway || newBalance === '' || isFuding}
        >
          {isFuding ? 'Saving...' : 'Set Balance'}
        </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}